const forecastList = ['FONASA', 'ISAPRE', 'DIPRECA', 'OTRO']

export default forecastList
